import React from 'react';
import img1 from './dentalcare.jpg'
const NotFound = () => {
    return (
        <div>
            <img src={img1} alt=""></img>

        </div>
    );
};

export default NotFound;